// https://git.xiaojukeji.com/BusinessAccessSecurity/frontend/Web/wsgsdk/blob/master/README.md
export default {
  online: {
    appId: '0204020202',
    env: 'AME', // test：测试环境；RUS：俄罗斯；AME：美东；CN：国内环境；G：不明地区时候默认域名；
    uid: '', // 650911284155535 线上加白灰度放量需要，测试环境可不传
    domainList: ['c.didi-food.com','pre-c.didi-food.com'], // 挑战应答
  },
}
